import { StyleSheet } from 'aphrodite'

import alert from './alert'

export default {
  alert: StyleSheet.create(alert)
}



// WEBPACK FOOTER //
// ./src/components/partials/ResponseAlert/style/index.js